(() => {
  const ROWS = 2;
  const caret = '<svg class="rr-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">expand_more</text></svg>';

  function setup(wrap) {
    const scroll = wrap.querySelector('.rr-vp__scroll');
    if (!scroll || scroll.querySelectorAll('label').length < 3) return;

    const option = wrap.closest('.rr-vp__opt');
    let name = (option?.querySelector('.rr-vp__name')?.textContent || 'options')
      .trim().toLowerCase().replace(/\s*\(.*?\)\s*/g, '').trim();
    if (!/s$/.test(name)) name += 's';
    const count = scroll.querySelectorAll('label').length;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rr-vp__more';
    btn.hidden = true;
    wrap.after(btn);

    const more = (wrap.dataset.rrMore || 'Voir les {count} {name}').replace('{count}', count).replace('{name}', name);
    const less = wrap.dataset.rrLess || 'Réduire';
    const label = (open) => (open ? less : more) + caret;

    const measure = () => {
      const was = wrap.classList.contains('rr-collapsed');
      if (was) wrap.classList.remove('rr-collapsed');
      const base = wrap.getBoundingClientRect().top;
      const rows = [];
      scroll.querySelectorAll('label').forEach((l) => {
        const r = l.getBoundingClientRect();
        const top = Math.round(r.top - base);
        let row = rows.find((x) => Math.abs(x.top - top) < 10);
        if (!row) { row = { top: top, bottom: 0 }; rows.push(row); }
        row.bottom = Math.max(row.bottom, Math.round(r.bottom - base));
      });
      rows.sort((a, b) => a.top - b.top);
      if (was) wrap.classList.add('rr-collapsed');
      return rows.length > ROWS ? rows[ROWS - 1].bottom + 10 : 0;
    };

    const open = () => {
      wrap.dataset.rrOpen = '1';
      wrap.classList.remove('rr-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      btn.innerHTML = label(true);
      moveSizeHelp();
    };

    const apply = () => {
      if (wrap.dataset.rrOpen === '1') return;
      const h = measure();
      if (!h) {
        wrap.classList.remove('rr-collapsed');
        btn.hidden = true;
        return;
      }
      wrap.style.setProperty('--rr-vp-h', h + 'px');
      wrap.classList.add('rr-collapsed');
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = label(false);

      // si la valeur choisie est masquée, on ouvre d'office
      const checked = scroll.querySelector('input:checked');
      const lab = checked && scroll.querySelector('label[for="' + CSS.escape(checked.id) + '"]');
      if (lab && lab.getBoundingClientRect().bottom - wrap.getBoundingClientRect().top > h) open();
    };

    btn.addEventListener('click', () => {
      if (wrap.classList.contains('rr-collapsed')) { open(); return; }
      wrap.dataset.rrOpen = '0';
      wrap.classList.add('rr-collapsed');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = label(false);
      wrap.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      moveSizeHelp();
    });

    wrap._rrApply = apply;
    apply();
  }

  /* ---------- « Sur mesure » prend place à la suite des tailles ----------
     Le bouton d'origine reste dans le bloc « Trouver ma taille », masqué : on pose une copie
     au bout de la grille des tailles et le clic est renvoyé à l'original. Comme ça, si Shopify
     re-rend le sélecteur de variantes, rien n'est perdu : on repose la copie.
     Si la liste est repliée, la copie sort de la grille pour ne pas se cacher dans les rangées
     masquées : elle se place alors après le lien « Voir les N tailles ».
     Le « Guide de taille » natif du thème laisse la place : il est désactivé dans les réglages,
     et masqué ici au cas où l'éditeur de thème le réactiverait en réécrivant le modèle. */
  const SM_CSS = [
    '.rr-vp__scroll .rr-sh__sm,.rr-vp__opt > .rr-sh__sm{min-height:42px;padding:9px 10px 9px 14px;gap:8px;border:1px dashed color-mix(in srgb,var(--rr-ink) 32%,transparent);border-radius:6px;background:var(--rr-white);color:var(--rr-ink);font-size:13.5px;font-weight:500;line-height:1.2;transition:border-color .2s,background .2s}',
    '.rr-vp__scroll .rr-sh__sm:hover,.rr-vp__opt > .rr-sh__sm:hover{border-style:solid;border-color:color-mix(in srgb,var(--rr-ink) 62%,transparent);background:var(--rr-sand)}',
    '.rr-vp__scroll .rr-sh__sm svg,.rr-vp__opt > .rr-sh__sm svg{width:15px;height:15px}',
    '.rr-vp__scroll .rr-sh__sm span,.rr-vp__opt > .rr-sh__sm span{font-size:9.5px;padding:3px 6px}',
    '.rr-vp__opt > .rr-sh__sm{margin-top:12px}',
    'html.rr-sm-moved .rr-sh__btns .rr-sh__sm{display:none}',
    'html.rr-sm-moved .rr-sh__btns{gap:0}',
    'html.rr-sm-moved .rr-vp__head dialog-component{display:none}'
  ].join('');

  function smStyle() {
    if (document.getElementById('rr-vp-sm')) return;
    const s = document.createElement('style');
    s.id = 'rr-vp-sm';
    s.textContent = SM_CSS;
    document.head.appendChild(s);
  }

  function moveSizeHelp() {
    const src = document.querySelector('rr-sizehelp .rr-sh__btns .rr-sh__sm');
    if (!src) return false;
    const opt = [...document.querySelectorAll('variant-picker .rr-vp__opt')]
      .find((o) => /taille|dimension/i.test(o.querySelector('.rr-vp__name')?.textContent || ''));
    const scroll = opt && opt.querySelector('.rr-vp__scroll');
    if (!scroll) return false;
    smStyle();

    let copy = opt.querySelector('.rr-sh__sm');
    if (!copy) {
      copy = src.cloneNode(true);
      copy.removeAttribute('id');
      copy.type = 'button';
      copy.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); src.click(); });
      document.documentElement.classList.add('rr-sm-moved');
    }

    const wrap = opt.querySelector('.rr-vp__wrap');
    const more = opt.querySelector('.rr-vp__more');
    const folded = !!wrap && wrap.classList.contains('rr-collapsed');
    if (folded && more) {
      if (copy.previousElementSibling !== more) more.after(copy);
    } else if (copy.parentElement !== scroll) {
      scroll.appendChild(copy);
    }
    return true;
  }

  const init = () => {
    document.querySelectorAll('variant-picker .rr-vp__wrap').forEach((wrap) => {
      if (wrap._rrApply) wrap._rrApply();
      else setup(wrap);
    });
    moveSizeHelp();
  };

  /* le bloc « Trouver ma taille » et le sélecteur peuvent arriver après nous : on guette. */
  const watch = () => {
    if (moveSizeHelp()) return;
    const stop = setTimeout(() => obs.disconnect(), 15000);
    const obs = new MutationObserver(() => {
      if (moveSizeHelp()) { obs.disconnect(); clearTimeout(stop); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  };

  const run = () => requestAnimationFrame(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', () => { run(); watch(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  let t = 0;
  window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(init, 200); }, { passive: true });
  document.addEventListener('variant:updated', () => setTimeout(init, 80));
})();

/* ===== Fiche produit, zone A : hauteur réelle de l'en-tête et bouton « Trouver ma taille » dans l'option Taille ===== */
(() => {
  const S = (window.__rrPdpA = window.__rrPdpA || {});
  if (S.ui) return;
  S.ui = 1;
  const root = document.documentElement;

  /* --rr-hh : hauteur réelle de l'en-tête collant (la galerie se colle dessous) */
  const hdr = document.querySelector('header.shopify-section') || document.querySelector('header');
  const hh = () => {
    const v = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
    if (v > 0) root.style.setProperty('--rr-hh', v + 'px');
  };
  hh();
  window.addEventListener('resize', hh, { passive: true });
  window.addEventListener('load', hh);
  if (hdr && window.ResizeObserver) new ResizeObserver(hh).observe(hdr);

  /* « Trouver ma taille » : une copie prend place dans l'en-tête de l'option Taille, le clic est renvoyé à l'original (masqué) */
  const place = () => {
    const src = document.querySelector('rr-sizehelp .rr-sh__btns .rr-sh__open');
    if (!src) return false;
    const opt = [...document.querySelectorAll('variant-picker .rr-vp__opt')].find((o) => /taille|dimension/i.test((o.querySelector('.rr-vp__name') || {}).textContent || ''));
    const head = opt && opt.querySelector('.rr-vp__head');
    if (!head) return false;
    if (!head.querySelector('.rr-sh__open')) {
      const c = src.cloneNode(true);
      c.classList.add('rr-sh__open--head');
      c.removeAttribute('id');
      c.type = 'button';
      c.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); src.click(); });
      head.appendChild(c);
    }
    root.classList.add('rr-open-moved');
    return true;
  };
  const run = () => requestAnimationFrame(place);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('variant:updated', () => setTimeout(place, 120));
  if (!place()) {
    const obs = new MutationObserver(() => { if (place()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 15000);
  }
})();

/* Zone C : apparitions au défilement de la fiche produit, puis FAQ à ouverture exclusive */
(() => {
if (window.__rrReveal) return;
window.__rrReveal = 1;
const W = window;
const D = document;
const R = D.documentElement;
if (!('IntersectionObserver' in W)) return;
if (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
/* [conteneur, [[sélecteur, délai de base (s), pas entre frères (s), ignoré sur mobile]]] */
const MAP = [
['.rr-pd', [['.rr-pd__eb', 0, 0], ['.rr-pd__t', 0.08, 0], ['.rr-pd__rte', 0.16, 0], ['.rr-pd__more', 0.16, 0], ['.rr-pd__keys', 0.24, 0], ['.rr-pd__acc > details', 0.1, 0.08]]],
['.rr-rel', [['.rr-rel__t', 0, 0], ['.rr-rel__sub', 0.08, 0], ['.rr-rel__it', 0.08, 0.08, true]]]
];
const pending = [];
let io = null;
let raf = 0;
const clean = (el) => { el.classList.remove('rr-pv', 'is-in'); el.style.removeProperty('--d'); };
const done = (el) => {
const i = pending.indexOf(el);
if (i < 0) return;
pending.splice(i, 1);
if (io) io.unobserve(el);
el.classList.add('is-in');
const d = parseFloat(el.style.getPropertyValue('--d')) || 0;
setTimeout(() => clean(el), (1.3 + d) * 1000);
};
const fail = () => { R.classList.remove('rr-rv-on'); pending.splice(0).forEach(clean); };
const sweep = () => {
raf = 0;
try {
const line = (W.innerHeight || R.clientHeight || 800) * 0.92;
pending.slice().forEach((el) => {
const r = el.getBoundingClientRect();
if (r.bottom <= 0 || r.top < line) done(el);
});
} catch (e) { fail(); }
};
const onScroll = () => { if (!raf) raf = W.requestAnimationFrame(sweep); };
const tag = (el, delay) => {
if (el.__rrpv || el.__rrfx || el.hidden || el.closest('.rr-rv,[data-no-fx],.rr-no-fx')) return;
const r = el.getBoundingClientRect();
if (!r.height || r.top < (W.innerHeight || 800) * 0.92) return;
el.__rrpv = 1;
el.__rrfx = 1;
el.style.setProperty('--d', delay.toFixed(2) + 's');
el.style.transition = 'none';
el.classList.add('rr-pv');
void el.offsetHeight;
el.style.transition = '';
pending.push(el);
io.observe(el);
};
const scan = () => {
if (!D.querySelector('.rr-pd, [data-rr-rel], rr-sticky-bar')) return;
try {
R.classList.add('rr-rv-on');
const narrow = W.matchMedia('(max-width:749px)').matches;
MAP.forEach((g) => {
D.querySelectorAll(g[0]).forEach((root) => {
g[1].forEach((t) => {
if (t[3] && narrow) return;
root.querySelectorAll(t[0]).forEach((el, k) => tag(el, t[1] + (t[2] ? Math.min(k, 3) * t[2] : 0)));
});
});
});
} catch (e) { fail(); }
};
try {
io = new IntersectionObserver((es) => {
es.forEach((e) => { if (e.isIntersecting || e.boundingClientRect.bottom <= 0) done(e.target); });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
} catch (e) { return; }
W.addEventListener('scroll', onScroll, { passive: true });
W.addEventListener('resize', onScroll, { passive: true });
W.addEventListener('beforeprint', () => pending.slice().forEach(done));
const go = () => { scan(); onScroll(); };
if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
W.addEventListener('load', go);
D.addEventListener('shopify:section:load', go);
})();

(() => {
if (window.__rrFaqExcl) return;
window.__rrFaqExcl = 1;
const D = document;
const rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
const shut = (it) => {
clearTimeout(it._t);
it.classList.remove('is-open');
if (rm.matches) { it.open = false; return; }
it._t = setTimeout(() => { if (!it.classList.contains('is-open')) it.open = false; }, 400);
};
const sync = (it) => {
if (!it || !it.classList.contains('is-open') || !D.querySelector('.rr-pd, [data-rr-rel], rr-sticky-bar')) return;
const list = it.parentNode;
if (!list) return;
list.querySelectorAll(':scope > .rrfq__it.is-open').forEach((o) => { if (o !== it) shut(o); });
};
D.addEventListener('click', (e) => {
const s = e.target.closest ? e.target.closest('.rrfq__it summary') : null;
if (!s) return;
const it = s.parentNode;
setTimeout(() => sync(it), 0);
});
D.addEventListener('shopify:block:select', (e) => {
const it = e.target;
if (it && it.classList && it.classList.contains('rrfq__it')) setTimeout(() => sync(it), 0);
});
})();

/* Lots (remises par quantité) : choix au clavier et aux lecteurs d'écran (radiogroup). Le composant natif ne change pas : on lit sa classe .quantity-break--selected */
(() => {
  const S = (window.__rrPdpA = window.__rrPdpA || {});
  if (S.qb) return;
  S.qb = 1;
  const ITEM = 'quantity-break-item';
  const on = (it) => it.classList.contains('quantity-break--selected');
  const off = (it) => it.classList.contains('quantity-break--disabled');
  let uid = 0;

  const sync = (group) => {
    const items = [...group.querySelectorAll(ITEM)];
    const cur = items.find((it) => on(it) && !off(it)) || items.find((it) => !off(it));
    items.forEach((it) => {
      it.setAttribute('role', 'radio');
      it.setAttribute('aria-checked', on(it) ? 'true' : 'false');
      if (off(it)) it.setAttribute('aria-disabled', 'true');
      else it.removeAttribute('aria-disabled');
      it.tabIndex = it === cur ? 0 : -1;
    });
  };

  const setup = (group) => {
    if (group._rrQb) { sync(group); return; }
    group._rrQb = 1;
    group.setAttribute('role', 'radiogroup');
    const lab = group.querySelector('.variant_label');
    if (lab) {
      if (!lab.id) lab.id = 'rr-qb-label-' + (++uid);
      group.setAttribute('aria-labelledby', lab.id);
    }
    sync(group);
    new MutationObserver(() => sync(group)).observe(group, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    group.addEventListener('keydown', (e) => {
      const it = e.target;
      if (!it || !it.matches || !it.matches(ITEM)) return;
      const live = [...group.querySelectorAll(ITEM)].filter((x) => !off(x));
      if (!live.length) return;
      const i = live.indexOf(it);
      let to = null;
      if (e.key === 'Enter' || e.key === ' ') to = it;
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = live[(i + 1) % live.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = live[(i - 1 + live.length) % live.length];
      else if (e.key === 'Home') to = live[0];
      else if (e.key === 'End') to = live[live.length - 1];
      if (!to || off(to)) return;
      e.preventDefault();
      if (!on(to)) to.click();
      sync(group);
      to.focus();
    });
  };

  const init = () => document.querySelectorAll('quantity-breaks').forEach(setup);
  const run = () => requestAnimationFrame(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('variant:updated', () => setTimeout(init, 120));
  document.addEventListener('shopify:section:load', run);
  if (!document.querySelector('quantity-breaks')) {
    const obs = new MutationObserver(() => { if (document.querySelector('quantity-breaks')) { obs.disconnect(); init(); } });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 15000);
  }
})();
